export const REFUND_REPORT_DATE_TYPES = [
  {
    id: 1,
    label: 'Data da restituição',
    value: 'refundDate',
  },
  {
    id: 2,
    label: 'Data de pagamento',
    value: 'paymentDate',
  },
];
